import React from "react";

const PagoPendiente = () => {
    return <div>PagoPendiente</div>;
};

export default PagoPendiente;
